/**
 * DaySeparator — separador de dia estilo WhatsApp.
 *
 * Exibe um pill centralizado com "Hoje", "Ontem" ou "DD/MM/AAAA".
 */
import { Box, Text } from '@mantine/core'

interface Props {
  date: Date
}

function formatDayLabel(date: Date): string {
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  const same = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()

  if (same(date, today)) return 'Hoje'
  if (same(date, yesterday)) return 'Ontem'

  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function DaySeparator({ date }: Props) {
  const label = formatDayLabel(date)

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 8,
        marginBottom: 8,
      }}
    >
      <Box
        style={{
          background: 'var(--ai-bg-elevated)',
          borderRadius: 999,
          padding: '2px 12px',
        }}
      >
        <Text size="xs" c="dimmed">
          {label}
        </Text>
      </Box>
    </Box>
  )
}
